import { Typography } from 'antd'

import { titlesOf } from '@/Containers/TransportationSection/Components'
import { formatDateUk } from '@/Ship/Helpers/fieldViews'

import type { KanbanCardRow, TransportRequestKanbanItem } from '@/Containers/TransportationSection/Components'

/**
 * Рядки картки канбану тендера під «Ід» (`SPEC-023` §4.5; легасі
 * `TenderKanbanMode.jsx:99-105`): «Назва» (обрізана), «Клієнт», «Тип авто»,
 * країни обох сторін через «, », «Крайній термін». Порожнє — «-», як у легасі.
 *
 * ДТ-02: легасі писав «Країна розвантаження» (однина) над списком країн і дату
 * в ISO `YYYY-MM-DD`; тут — «Країни розвантаження» і формат дат застосунку.
 */
export const tenderKanbanRows = (item: TransportRequestKanbanItem): KanbanCardRow[] => [
    { label: 'Назва', value: item.title ? <Typography.Text ellipsis>{item.title}</Typography.Text> : '-' },
    { label: 'Клієнт', value: item.client?.title || '-' },
    { label: 'Тип авто', value: titlesOf(item.typesCars) || '-' },
    { label: 'Країни завантаження', value: titlesOf(item.loadingCountries) || '-' },
    { label: 'Країни розвантаження', value: titlesOf(item.unloadingCountries) || '-' },
    { label: 'Крайній термін', value: item.deadline ? formatDateUk(item.deadline) : '-' },
]
